import { useRef as y, useCallback as g } from "react";
import { normalizeSnapPoint as k } from "./index.es789.js";
const C = (r, s, l, X, x, Y, b, E, L, z, M, h, d, O) => {
  const i = y(null), $ = y(0), S = y(0), m = g(
    (t) => {
      if (!i.current || !r.current) return;
      const a = "touches" in t ? t.touches[0].clientX : t.clientX, f = "touches" in t ? t.touches[0].clientY : t.clientY;
      let c = 0;
      s === "bottom" ? c = f - i.current.y : s === "top" ? c = i.current.y - f : s === "right" ? c = a - i.current.x : c = i.current.x - a;
      const e = $.current + Math.max(0, c);
      S.current = e, s === "bottom" ? r.current.style.transform = `translateY(${e}px)` : s === "top" ? r.current.style.transform = `translateY(-${e}px)` : s === "right" ? r.current.style.transform = `translateX(${e}px)` : r.current.style.transform = `translateX(-${e}px)`;
      const u = d(), n = e / u;
      E && E(t, n), "touches" in t && t.preventDefault();
    },
    [s, r, d, E]
  ), o = g(
    (t) => {
      if (!r.current) return;
      h(!1), i.current = null, document.removeEventListener("mousemove", m), document.removeEventListener("mouseup", o), document.removeEventListener("touchmove", m), document.removeEventListener("touchend", o), document.removeEventListener("touchcancel", o);
      const a = d(), c = S.current / a;
      if (r.current.style.transition = "transform 300ms ease-out", c > b) {
        Y(!1);
        return;
      }
      if (l.length > 0) {
        const e = l.map(k);
        let u;
        if (z) {
          const n = e.findIndex(
            (v) => v === k(X || e[0])
          );
          c > 0 && n < e.length - 1 ? u = e[n + 1] : c < 0 && n > 0 ? u = e[n - 1] : u = e[n];
        } else
          u = e.reduce(
            (n, v) => Math.abs(v - c) < Math.abs(n - c) ? v : n
          );
        if (x) {
          const n = l[e.indexOf(u)];
          x(n);
        }
        if (O(u, !0), L) {
          const n = l[e.indexOf(u)];
          L(t, n);
        }
      } else
        r.current.style.transform = "";
    },
    [
      r,
      h,
      d,
      b,
      Y,
      l,
      z,
      X,
      x,
      O,
      L,
      m
    ]
  );
  return {
    handleDragStart: g(
      (t) => {
        if (!l.length || !r.current) return;
        h(!0);
        const a = "touches" in t ? t.touches[0].clientX : t.clientX, f = "touches" in t ? t.touches[0].clientY : t.clientY;
        i.current = { x: a, y: f }, $.current = M(), r.current.style.transition = "none", "touches" in t ? (document.addEventListener("touchmove", m, { passive: !1 }), document.addEventListener("touchend", o), document.addEventListener("touchcancel", o)) : (document.addEventListener("mousemove", m), document.addEventListener("mouseup", o)), t.preventDefault();
      },
      [
        l.length,
        r,
        h,
        M,
        m,
        o
      ]
    ),
    handleDragMove: m,
    handleDragEnd: o
  };
};
export {
  C as useDrawerDragging
};
//# sourceMappingURL=index.es5628.js.map
